import { DateTime } from 'luxon';
import { AbstractViewModel } from '../../../abstract.view.model';
import { FbItemApiModel } from '../../../api-model/order/fb-item/fb-item.api.model';
import { FbItemMembershipPriceViewModel } from './fb-item-membership-price.view.model';
import { FbItemModifierItemViewModel } from './fb-item-modifier-item.view.model';
import { FbItemSubArticleViewModel } from './fb-item-sub-article.view.model';
import { NutritionalInfoModel } from '../../../catering/nutritional-info.response.model';

export class FbItemViewModel extends AbstractViewModel<FbItemApiModel> {
  id: string;
  articleId: string;
  quantity: number;
  voucherNumber: string;
  voucherName: string;
  name: string;
  comboMinPrice?: number;
  price: number;
  taxValue: number;
  pickupTime: DateTime;
  defaultPriceLevelPrice: number;
  subArticleList: FbItemSubArticleViewModel[] = [];
  modifierItemList: FbItemModifierItemViewModel[] = [];
  itemEarnedPoints: number;
  itemRedemptionPoints: number;
  promotionId: string;
  promotionName: string;
  membershipPrices: FbItemMembershipPriceViewModel[] = [];
  graphics: string[];
  assignedSeatId: string;
  assignedScreeningId: string;

  nutritionalInfo?: NutritionalInfoModel;

  constructor(protected apiModel: FbItemApiModel = new FbItemApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.id = this.apiModel.id;
    this.articleId = this.apiModel.articleId;
    this.quantity = this.apiModel.quantity;
    this.voucherNumber = this.apiModel.voucherNumber;
    this.voucherName = this.apiModel.voucherName;
    this.name = this.apiModel.name;
    this.price = this.apiModel.price;
    this.comboMinPrice = this.apiModel.comboMinPrice;
    this.taxValue = this.apiModel.taxValue;
    this.pickupTime = this.apiModel.pickupTime ? DateTime.fromISO(this.apiModel.pickupTime) : null;
    this.defaultPriceLevelPrice = this.apiModel.defaultPriceLevelPrice;
    this.subArticleList = this.apiModel.subArticleList.map((subArticle) => new FbItemSubArticleViewModel(subArticle));
    this.modifierItemList = this.apiModel.modifierItemList.map((modifierItem) => new FbItemModifierItemViewModel(modifierItem));
    this.itemEarnedPoints = this.apiModel.itemEarnedPoints;
    this.itemRedemptionPoints = this.apiModel.itemRedemptionPoints;
    this.promotionId = this.apiModel.promotionId;
    this.promotionName = this.apiModel.promotionName;
    this.membershipPrices = this.apiModel.membershipPrices.map((membershipPrice) => new FbItemMembershipPriceViewModel(membershipPrice));
    this.graphics = this.apiModel.graphics;
    this.assignedSeatId = this.apiModel.assignedSeatId;
    this.assignedScreeningId = this.apiModel.assignedScreeningId;
  }

  toApiModel(): FbItemApiModel {
    return Object.assign(this.apiModel, {
      articleId: this.articleId,
      quantity: this.quantity,
      subArticleList: this.subArticleList.map((subArticle) => subArticle.toApiModel()),
      modifierItemList: this.modifierItemList.map((modifierItem) => modifierItem.toApiModel())
    });
  }

  hasVoucher() {
    return Boolean(this.voucherNumber) || Boolean(this.voucherName);
  }

  public hasVoucherNumber(number: string) {
    return this.voucherNumber === number;
  }

  get graphicUrl(): string {
    return this.graphics && this.graphics.length > 0 ? this.graphics[0] : null;
  }
}
